import { Component, OnInit, OnDestroy, ViewChild, Input, Output, EventEmitter, NgZone } from '@angular/core';
import { IonContent } from '@ionic/angular';  // renamed from Content

// import { Events } from '@ionic/angular';  // deprecated in Ionic 5
import { Events } from 'src/app/services/events/events.service';  // workaround for events

import { TranslateService } from '@ngx-translate/core';
import { ApiService } from 'src/app/services/api/api.service';
import { CommonService } from 'src/app/services/common/common.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { GeoPosition, GeoStatus } from 'src/app/services/geolocation/geoposition';
import { GeolocationWrapperService } from 'src/app/services/geolocation/geolocation.service';
import { SiteStructure } from 'src/app/services/global/structure';

import * as moment from 'moment'; 

@Component({
  selector: 'mygeoinfo',
  templateUrl: './mygeoinfo.component.html',
  styleUrls: ['./mygeoinfo.component.scss'],
})
export class MygeoinfoComponent implements OnInit, OnDestroy  {

  @ViewChild(IonContent) content: IonContent;   
  // https://toddmotto.com/component-events-event-emitter-output-angular-2
  @Input() pageName:string; //@Input('pageName') pageName;
  @Output() outGeofenceUpdate: EventEmitter<boolean> = new EventEmitter<boolean>();
  
  consoleLog:boolean = false;

  // specific page information (technical identifier stuff)
  public isShowGeolocationInfo:boolean = false;
  public dotGpsUrl:string = "assets/imgs/dotGps.png";
  public dotIpsUrl:string = "assets/imgs/dotIps.png";

  // Subscription: Geolocation - Gps Position
  //private GpsSubscription: Subscription;
  public GpsPosition:GeoPosition = new GeoPosition();
  public GpsStatus:GeoStatus = new GeoStatus();
  public isGpsWatching:boolean = false;
  
  // Subscription: Geolocation - Ips Position
  //private IpsSubscription: Subscription;
  public IpsPosition:GeoPosition = new GeoPosition();
  public IpsStatus:GeoStatus = new GeoStatus();
  public isIpsWatching:boolean;

  // Geofence related 
  public isShowGeofenceStatus:boolean = true;
  public EventSite:SiteStructure = new SiteStructure();
  public NearestSite:SiteStructure = new SiteStructure();
  public GeofenceFlag:boolean = false;     // does Geofence apply to this feature

  
  constructor(
     public globalProvider: GlobalService
    , private geolocationProvider: GeolocationWrapperService
    , public translate: TranslateService
    , public zone: NgZone 
    , public events: Events
    , public apiProvider: ApiService
    // public navCtrl: NavController, public navParams: NavParams
  ) 
  {
    this.consoleLog = this.globalProvider.consoleLog_mygeoinfo;
    if (this.consoleLog) console.log('mygeoinfo.ctor - LifeCycle');
  }

  // ----------------------------------------------------
  // -------- COMPONENT LIFE-CYCLE EVENTS  --------------
  // ----------------------------------------------------
  ngOnInit() // ngAfterViewInit()
  {
    if (this.consoleLog) console.log('mygeoinfo.ngOnInit - ' + this.pageName + ' - LifeCycle');
    this.Initialize("ctor");
  }

  // this IS called -- just before the component is removed
  ngOnDestroy() 
  { 
    if (this.consoleLog) console.log('mygeoinfo.ngOnDestroy - ' + this.pageName + ' - LifeCycle');
    this.subscriptions(false, "mygeoinfo.ngOnDestroy - LifeCycle");
  }

  // ----------------------------------------------------
  // --------------  INITIALIZE   -----------------------
  // ----------------------------------------------------
  Initialize(context:string)
  {
    if (this.consoleLog) console.log('mygeoinfo.Initialize');
    this.subscriptions(true, "mygeoinfo.Initialize");
    this.SetGeofenceSite();
  }

  // ----------------------------------------------------
  // ---------------      SUBSCRIPTIONS       -----------
  // ----------------------------------------------------
  subscriptions(isSubscribe:boolean, context:string)
  {
    if (this.consoleLog) console.log('mygeoinfo.Subscriptions: ' + (isSubscribe ? "SUBSCRIBE" : "UNSUBSCRIBE") + ' - ' + this.pageName + " " + context);
    
    this.SubscribeToGpsStatus(isSubscribe);
    this.SubscribeToIpsStatus(isSubscribe);
  }


  // ----------------------------------------------------
  // -------------  GEOFENCE INFORMATION  ---------------
  // ----------------------------------------------------
  public SetGeofenceSite()
  {
    this.zone.run(() => 
    {
      if (this.consoleLog) console.log("mygeoinfo.SetGeofenceSite - " + this.pageName);
      
      this.NearestSite = this.globalProvider.SiteProximity.GetNearestSite();   // in case we are offsite as an FYI reference point
      this.EventSite = this.globalProvider.SiteProximity.GetNearestGeofenceSite();  // GeoFence related
      
      if (this.consoleLog) console.log("mygeoinfo.SetGeofenceSite - " + this.pageName + " - NearestSite:" + this.NearestSite.SiteId, this.NearestSite);
      if (this.consoleLog) console.log("mygeoinfo.SetGeofenceSite - " + this.pageName + " - EventSite:" + this.EventSite.SiteId, this.EventSite);
    });
  }


  public SetGeofenceFlag(GeofenceFlag:boolean)
  {
    this.zone.run(() => 
    {
      if (this.consoleLog) console.log("mygeoinfo.SetGeofenceFlag - " + this.pageName + " GeofenceFlag:" + GeofenceFlag);
      this.GeofenceFlag = GeofenceFlag;
      this.SetGeofenceSite();
    });
  }

  // ----------------------------------------------------
  // -------------    DISPLAY CONTROL     ---------------
  // ----------------------------------------------------
  public ShowGeofenceStatus(isShowGeofenceStatus:boolean)
  {
    this.isShowGeofenceStatus = isShowGeofenceStatus;
  }
  public ShowGeolocationInfo(isShowGeolocationInfo:boolean)
  {
    this.isShowGeolocationInfo = isShowGeolocationInfo;
  }
  public btnToggleGeoInfo()
  {
    this.zone.run(() => 
    {
      console.log("mygeoinfo.btnToggleGeoInfo - " + this.pageName + " from " + this.isShowGeolocationInfo);
      this.isShowGeolocationInfo = !this.isShowGeolocationInfo;
    });
  }


  // ----------------------------------------------------
  // --------------- API FUNCTION CALLS       -----------
  // ----------------------------------------------------
  CallGetSiteInfoList(context:string)
  {
    if (this.consoleLog) console.log("mygeoinfo.CallGetSiteInfoList - " + this.pageName + " - " + context);

    this.apiProvider.GetSiteInfoList(false) // do not ignore empty sites with no personnel
    .then(data => { 
      this.zone.run(() => {
        this.globalProvider.SiteProximity.SetFromApiResponse(data);
        this.SetGeofenceSite();
        let isDistanceWithinGeoFenceRange:boolean = this.globalProvider.SiteProximity.IsDistanceWithinGeoFenceRange();
        this.outGeofenceUpdate.emit(isDistanceWithinGeoFenceRange); // notify parent screen that geofence changed
      });
     }
    , 
    errorMessage => {
      this.zone.run(() => {
        console.warn("error", errorMessage);
        // alert("Unable to read Site list");
      });
    });
  }

  private UpdateSiteGeofence()
  {
    if (this.consoleLog) console.log("mygeoinfo.UpdateSiteGeofence - " + this.pageName);
    if (!this.HasTimeOrPositionChangedEnough(this.GpsPosition)) // NOTE:  what about IPS position? LATER
    {
      // if (this.consoleLog) 
      if (this.consoleLog) console.log("mygeoinfo.UpdateSiteGeofence - " + this.pageName + " - not enough time or distance since last check");
      return;
    }
    this.CallGetSiteInfoList("UpdateSiteGeofence");
  }

  _thresholdGeofenceDistanceMeters: number = 50;
  _lastUsedGeofenceLatitude: number = 0;
  _lastUsedGeofenceLongitude: number = 0;

  _thresholdGeofenceTimeSeconds: number = 15; // to do -- change to 15
  _lastUsedGeofenceTime: number = 0;

  private HasTimeOrPositionChangedEnough(geoPosition:GeoPosition):boolean
  {
    if (this.consoleLog) console.log("GeolocationService.HasTimeOrPositionChangedEnough - START");
    if ( this.IsPositionNewEnough(geoPosition, this._thresholdGeofenceTimeSeconds) 
      || this.HasPositionChangedEnough(geoPosition) ) 
    {
      if (this.consoleLog) console.log("mygeoinfo.HasTimeOrPositionChangedEnough: YES");
      return true;
    }
    else
    {
      if (this.consoleLog) console.log("mygeoinfo.HasTimeOrPositionChangedEnough: NO");
      return false;
    }
  }


  IsPositionNewEnough(geoPosition:GeoPosition, thresholdGeofenceTimeSeconds:number):boolean
  {
    if (this.consoleLog) console.log("mygeoinfo.IsPositionNewEnough");
    if ((!geoPosition) || (!geoPosition.timestamp))
    {
      if (this.consoleLog) console.log("mygeoinfo.IsPositionNewEnough - NO TIMESTAMP");
      return false;
    }
     
    let currentGeofenceTime = geoPosition.timestamp; // save the current time (we may use it to make it the sincelast below)

    if (this.consoleLog) console.log("mygeoinfo.IsPositionNewEnough -" 
                                   + " currentGeofenceTime:" + currentGeofenceTime
                                   + " " + moment(currentGeofenceTime).format("YYYY-MM-DDTHH:mm:ss")
                                   );   
    if (this.consoleLog) console.log("mygeoinfo.IsPositionNewEnough -" 
                                   + " lastUsedGeofenceTime:" + this._lastUsedGeofenceTime
                                   + " " + moment(this._lastUsedGeofenceTime).format("YYYY-MM-DDTHH:mm:ss")
                                   );   

    var now = moment(currentGeofenceTime); //todays date
    var end = moment(this._lastUsedGeofenceTime); // another date
    var duration = moment.duration(now.diff(end));
    var ageSeconds = duration.asSeconds();

    if (this.consoleLog) console.log("mygeoinfo.IsPositionNewEnough - "
                + " Timestamp: " + moment(now).format("YYYY-MM-DDTHH:mm:ss")
                + " ageSeconds: " + ageSeconds
                + " Humanized: " + moment.duration(now.diff(end)).humanize()
               );

    if (ageSeconds < thresholdGeofenceTimeSeconds)
    {
      if (this.consoleLog) console.warn("mygeoinfo.IsPositionNewEnough - NO: age(" + ageSeconds + ") < threshold(" + thresholdGeofenceTimeSeconds + ") seconds");
      return false;
    }

    if (this.consoleLog) console.warn("mygeoinfo.IsPositionNewEnough - YES: age(" + ageSeconds + ") > threshold(" + thresholdGeofenceTimeSeconds + ") seconds");
    this._lastUsedGeofenceTime = currentGeofenceTime;
    return true;
  }

  HasPositionChangedEnough(geoPosition:GeoPosition)
  {
    if ((!geoPosition) || (!geoPosition.coords))
    {
      if (this.consoleLog) console.log("mygeoinfo.HasPositionChangedEnough - NO POSITION");
      return false;
    }

    let lat1:number = Number(geoPosition.Latitude);
    let lon1:number = Number(geoPosition.Longitude);
    if ((this._lastUsedGeofenceLatitude === 0) && (this._lastUsedGeofenceLongitude === 0))
    {
      if (this.consoleLog) console.log("mygeoinfo.HasPositionChangedEnough - NO PREVIOUS TO COMPARE");
      this._lastUsedGeofenceLatitude = lat1;
      this._lastUsedGeofenceLongitude = lon1; 
      return false;
    }

    let lat2:number = this._lastUsedGeofenceLatitude;
    let lon2:number = this._lastUsedGeofenceLongitude;

    let currentDistanceSinceLastGeofenceMeters 
    = this.getDistanceFromLatLonInMeters(lat1, lon1, lat2, lon2);
    if (currentDistanceSinceLastGeofenceMeters < this._thresholdGeofenceDistanceMeters)
    {
      if (this.consoleLog) console.warn("mygeoinfo.HasPositionChangedEnough - NO (current:" + currentDistanceSinceLastGeofenceMeters + ") < threshold(" + this._thresholdGeofenceDistanceMeters + ")");
      return false;
    }

    if (this.consoleLog) console.warn("mygeoinfo.HasPositionChangedEnough - YES (current:" + currentDistanceSinceLastGeofenceMeters + ") > threshold(" + this._thresholdGeofenceDistanceMeters + ")");
    this._lastUsedGeofenceLatitude = lat1;
    this._lastUsedGeofenceLongitude = lon1; 
    return true;
  }

  getDistanceFromLatLonInMeters(lat1:number, lon1:number, lat2:number, lon2:number) 
  {
    // ref: https://stackoverflow.com/questions/18883601/function-to-calculate-distance-between-two-coordinates
    // move this to common code later....

    if (this.consoleLog) console.log("mygeoinfo.getDistanceFromLatLonInMeters");
    var R = 6371; // Radius of the earth in km
    var M = 1000; // Meters multiplier
    var dLat = this.deg2rad(lat2-lat1);  // deg2rad below
    var dLon = this.deg2rad(lon2-lon1); 
    var a = 
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * 
      Math.sin(dLon/2) * Math.sin(dLon/2)
      ; 
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
    var d = M * R * c; // Distance in meters
    return d;
  }

  deg2rad(deg) {
    // move this to common code later....
    return deg * (Math.PI/180)
  }

  // ==========================================================
  // == ALMOST A DIRECT COPY OF GPS/IPS in STATUS COMPONENT ===
  // ==========================================================

  // ----------------------------------------------------
  // --------------- LOCATION CONTROLLER WATCH ----------
  // ----------------------------------------------------

  // https://forum.ionicframework.com/t/events-pub-sub-how-to-unsubscribe-in-lifecycle-hook/50596/5?u=xme
  private _GpsEventSub: (geoStatus:GeoStatus) => void;
  DefineGpsEventSub()
  {
    // NOTE!  remember to call this just before subscribing to the event
    if (this.consoleLog) console.log("mygeoinfo.DefineGpsEventSub" + ' - ' + this.pageName);
    this._GpsEventSub = (geoStatus:GeoStatus) => {
      if (this.consoleLog) console.log("mygeoinfo.GpsEventSub - geoStatus: ", geoStatus);
      this.onGpsStatus(geoStatus);
    };
  }

  private _GpsPositionEventSub: (geoPosition:GeoPosition) => void;
  DefineGpsPositionEventSub()
  {
    // NOTE!  remember to call this just before subscribing to the event
    if (this.consoleLog) console.log("mygeoinfo._GpsPositionEventSub" + ' - ' + this.pageName);
    this._GpsPositionEventSub = (geoPosition:GeoPosition) => {
      this.onGpsResponse(geoPosition);
    };
  }

  public isActiveSubscriptionGpsStatus:boolean = false;
  SubscribeToGpsStatus(isSubscribe:boolean)
  {   
    if (this.consoleLog) console.log("mygeoinfo.GPS: " + (isSubscribe ? "SUBSCRIBE" : "UNSUBSCRIBE") + ' - ' + this.pageName);

    if (isSubscribe)
    {
      this.GpsStatus = this.geolocationProvider.GetGpsStatus();  // get initial status
      this.isGpsWatching = this.geolocationProvider.isGpsWatching();

      this.GpsPosition = this.geolocationProvider.GetGpsPosition();  // get initial position
      this.onGpsResponse(this.GpsPosition);

      if (this.isActiveSubscriptionGpsStatus === true)
      {
        if (this.consoleLog) console.log("mygeoinfo.GPS - ALREADY ACTIVE");
        return;
      }
      this.isActiveSubscriptionGpsStatus = true;
      this.DefineGpsEventSub();
      this.events.subscribe('mygeo' + this.pageName, 'geolocation:gpsStatus', this._GpsEventSub);

      this.DefineGpsPositionEventSub();
      this.events.subscribe('mygeo' + this.pageName, 'geolocation:gpsPosition', this._GpsPositionEventSub);
    }
    else
    {
      //this.GpsSubscription.unsubscribe();
      this.events.unsubscribe('mygeo' + this.pageName, 'geolocation:gpsStatus', this._GpsEventSub);
      this.events.unsubscribe('mygeo' + this.pageName, 'geolocation:gpsPosition', this._GpsPositionEventSub);
      this.isActiveSubscriptionGpsStatus = false;
    }
  }

  onGpsResponse(geoPosition:GeoPosition) 
  {
    if (this.consoleLog) console.log("mygeoinfo.onGpsResponse" + ' - ' + this.pageName, geoPosition);
    this.zone.run(() => {
      this.isGpsWatching = this.geolocationProvider.isGpsWatching();
      this.GpsPosition = geoPosition;
      this.GpsStatus = geoPosition.GeoStatus; 
      this.UpdateSiteGeofence();
    });
  }

  onGpsStatus(geoStatus:GeoStatus)
  {
    if (this.consoleLog) console.log("mygeoinfo.onGpsStatus" + ' - ' + this.pageName, geoStatus);
    this.zone.run(() => {
      this.GpsStatus = geoStatus;
      this.isGpsWatching = this.geolocationProvider.isGpsWatching();
    });
  }

  public RefreshGpsStatus()
  {
    // allow parent page to force an inquiry, say on its page initialization
    if (this.consoleLog) console.log("mygeoinfo.RefreshGpsStatus" + ' - ' + this.pageName, this.GpsStatus);
    this.zone.run(() => {
      this.GpsStatus = this.geolocationProvider.GetGpsStatus();
      this.isGpsWatching = this.geolocationProvider.isGpsWatching();
      this.UpdateSiteGeofence();
    });
  }

  public RefreshGpsPosition()  // onGpsResponse(geoPosition:GeoPosition) 
  {
    // allow parent page to force an inquiry, say on its page initialization
    if (this.consoleLog) console.log("mygeoinfo.RefreshGpsPosition" + ' - ' + this.pageName);
    this.zone.run(() => {
      this.isGpsWatching = this.geolocationProvider.isGpsWatching();
      this.GpsPosition = this.geolocationProvider.GetGpsPosition();
      this.GpsStatus = this.geolocationProvider.GetGpsStatus();
      this.UpdateSiteGeofence();
    });
  }

  
  // ----------------------------------------------------
  // ----------- IPS LOCATION CONTROLLER WATCH ----------
  // ----------------------------------------------------

  // https://forum.ionicframework.com/t/events-pub-sub-how-to-unsubscribe-in-lifecycle-hook/50596/5?u=xme
  private _IpsEventSub: (geoStatus:GeoStatus) => void;
  DefineIpsEventSub()
  {
    // NOTE!  remember to call this just before subscribing to the event
    if (this.consoleLog) console.log("mygeoinfo.DefineIpsEventSub" + ' - ' + this.pageName);
    this._IpsEventSub = (geoStatus:GeoStatus) => {
      this.onIpsStatus(geoStatus);
    };
  }

  private _IpsPositionEventSub: (geoPosition:GeoPosition) => void;
  DefineIpsPositionEventSub()
  {
    // NOTE!  remember to call this just before subscribing to the event
    if (this.consoleLog) console.log("mygeoinfo.DefineIpsPositionEventSub" + ' - ' + this.pageName);
    this._IpsPositionEventSub = (geoPosition:GeoPosition) => {
      this.onIpsResponse(geoPosition);
    };
  }

  public isActiveSubscriptionIpsStatus: boolean = false;
  SubscribeToIpsStatus(isSubscribe:boolean)
  {   
    if (this.consoleLog) console.log("mygeoinfo.IPS: " + (isSubscribe ? "SUBSCRIBE" : "UNSUBSCRIBE") + ' - ' + this.pageName);

    if (isSubscribe)
    {
      this.IpsStatus = this.geolocationProvider.GetIpsStatus();  // get initial status
      this.isIpsWatching = this.geolocationProvider.isIpsWatching();

      this.IpsPosition = this.geolocationProvider.GetIpsPosition();  // get initial position
      this.onIpsResponse(this.IpsPosition);

      if (this.isActiveSubscriptionIpsStatus === true)
      {
        if (this.consoleLog) console.log("mygeoinfo.IPS - ALREADY ACTIVE");
        return;
      }
      this.isActiveSubscriptionIpsStatus = true;
      this.DefineIpsEventSub();
      this.events.subscribe('mygeo' + this.pageName, 'geolocation:ipsStatus', this._IpsEventSub);

      this.DefineIpsPositionEventSub();
      this.events.subscribe('mygeo' + this.pageName, 'geolocation:ipsPosition', this._IpsPositionEventSub);
    }
    else
    {
      this.events.unsubscribe('mygeo' + this.pageName, 'geolocation:ipsStatus', this._IpsEventSub);
      this.events.unsubscribe('mygeo' + this.pageName, 'geolocation:ipsPosition', this._IpsPositionEventSub);
      this.isActiveSubscriptionIpsStatus = false;
    }
  }

  onIpsResponse(geoPosition:GeoPosition) 
  {
    if (this.consoleLog) console.log("mygeoinfo.onIpsResponse" + ' - ' + this.pageName, geoPosition);
    this.zone.run(() => {
      this.isIpsWatching = this.geolocationProvider.isIpsWatching();
      this.IpsPosition = geoPosition;
      this.IpsStatus = geoPosition.GeoStatus; 
      this.UpdateSiteGeofence();
    });
  }

  onIpsStatus(geoStatus:GeoStatus)
  {
    if (this.consoleLog) console.log("mygeoinfo.onIpsStatus" + ' - ' + this.pageName, geoStatus);
    this.zone.run(() => {
      this.IpsStatus = geoStatus;
      this.isIpsWatching = this.geolocationProvider.isIpsWatching();
    });
  }

  public RefreshIpsStatus()
  {
    // allow parent page to force an inquiry, say on its page initialization
    if (this.consoleLog) console.log("mygeoinfo.RefreshIpsStatus" + ' - ' + this.pageName, this.IpsStatus);
    this.zone.run(() => {
      this.IpsStatus = this.geolocationProvider.GetIpsStatus();
      this.isIpsWatching = this.geolocationProvider.isIpsWatching();
      this.UpdateSiteGeofence();
    });
  }

  public RefreshIpsPosition()  // onIpsResponse(geoPosition:GeoPosition)
  {
    // allow parent page to force an inquiry, say on its page initialization
    if (this.consoleLog) console.log("mygeoinfo.RefreshIpsPosition" + ' - ' + this.pageName);
    this.zone.run(() => {
      this.isIpsWatching = this.geolocationProvider.isIpsWatching();
      this.IpsPosition = this.geolocationProvider.GetIpsPosition();
      this.IpsStatus = this.geolocationProvider.GetIpsStatus();
      this.UpdateSiteGeofence();
    });
  }

}
